import React from 'react';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Linkedin,
} from 'lucide-react';

const Footer: React.FC = () => {
  const socialLinks = [
    { icon: <Linkedin className="w-5 h-5" />, href: 'https://www.linkedin.com/company/hybridbeetech/', label: 'LinkedIn' }
  ];

  return (
    <footer className="bg-secondary-900 text-white border-t border-border">
      <div className="container-custom py-12">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
          <div className="flex-1 space-y-4">
            <div className="flex items-center space-x-3">
              <div>
                <h3 className="text-xl font-bold">Hybrid Bee Technology</h3>
                <p className="text-gray-500 text-sm">Cloud & DevSecOps Solutions</p>
              </div>
            </div>
            
            <p className="text-gray-400 leading-relaxed max-w-2xl">
              Especialistas en soluciones Cloud y DevSecOps, desarrollando infraestructuras 
              escalables y seguras para empresas que buscan optimizar sus operaciones tecnológicas.
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-3">
              <a 
                href="https://wa.me/5491131891414" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-gray-400 hover:text-accent-400 transition-colors duration-200"
              >
                <Phone className="w-4 h-4 text-accent-500" />
                <span>(+54) 11 3189 1414</span>
              </a>
              <a 
                href="mailto:hello@hbeeit.com"
                className="flex items-center space-x-3 text-gray-400 hover:text-accent-400 transition-colors duration-200"
              >
                <Mail className="w-4 h-4 flex-shrink-0 text-accent-500" />
                <span>hello@hbeeit.com</span>
              </a>
              <div className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-accent-500" />
                <span>Centro Empresarial Libertador, Av. del Libertador 7208, C1429 Cdad. Autónoma de Buenos Aires, Argentina</span>
              </div>
            </div>

            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 bg-surface-raised hover:bg-accent-500 border border-border hover:border-accent-500 rounded-lg flex items-center justify-center transition-colors duration-200"
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-custom py-6">
          <div className="text-center">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Hybrid Bee Technology. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
